export function fetchStockId() {
  const path = window.location.pathname;
  const regex = /\/stock\/(\d+)\/?/;
  const match = path.match(regex);
  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
}

export function fetchAbsolutePath() {
  const currentPath = window.location.pathname;
  return currentPath;
}

export function fetchSecurityName() {
  const pathName = window.location.pathname.split('/')[3];
  return pathName;
}
